import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledMainContainer = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding-top: ${spacing * 6}px;
        padding-bottom: ${spacing * 6}px;
    `
)

export const StyledChartContainer = styled.div`
    width: 100%;
    .recharts-default-legend {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }
`

export const StyledLegendContainer = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: row;
        gap: ${spacing * 6}px;
        align-items: center;
        justify-content: flex-end;
    `
)

export const StyledLegendItem = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: row;
        gap: ${spacing * 2}px;
        align-items: center;
    `
)

export const StyledLegendDot = styled.div<{$color: string}>(
    ({theme: {spacing}, $color}) => css`
        width: ${spacing * 3}px;
        height: ${spacing * 3}px;
        border-radius: 50%;
        background-color: ${$color};
    `
)

export const StyledTooltipContainer = styled.div(
    ({theme: {spacing, palette, shadows}}) => css`
        background: ${palette.neutral.white};
        padding: ${spacing * 3}px;
        border: 1px solid ${palette.neutral[200]};
        border-radius: ${spacing * 2}px;
        box-shadow: ${shadows.lg};
    `
)

export const StyledTooltipItem = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        margin-top: ${spacing}px;
    `
)

export const StyledTooltipDot = styled.div<{$color: string}>(
    ({theme: {spacing}, $color}) => css`
        width: ${spacing * 3}px;
        height: ${spacing * 3}px;
        border-radius: 50%;
        background-color: ${$color};
    `
)
